var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("错误页面")]),_c('p',[_vm._v(_vm._s(this.$route.query.msg))]),_c('a',{on:{"click":function($event){return this.$router.push('/')}}},[_vm._v("返回首页")])])}
var staticRenderFns = []

export { render, staticRenderFns }